import { SEO } from "../commonSeo/SEO"; // 🟢 Import SEO Component (Adjust relative path if needed)
import { HeroSection } from "./HeroSection";
// import { SearchHomepage } from "./SearchHomepage";
import { CategoriesHomepage } from "./CategoriesHomepage";
import { FeaturedExpertsHomepage } from "./FeaturedExpertsHomepage";

// import { MobileAppCTA } from "./MobileAppCTA";
import { BlogHomepage } from "./BlogHomepage";
import { TestimonialsHomepage } from "./TestimonialsHomepage";
import homeShareBanner from "../../assets/trueAdvisoLogo/advisofav-icon.png";

export default function Home() {
  return (
    <>
      {/* 🟢 DEFAULT HOMEPAGE SEO META TAGS */}
      <SEO 
        title="Online Consultation with Verified Astrologers, Lawyers & Doctors"
        description="TrueAdviso: talk to verified astrologers & lawyers by the minute, or doctor consultations by session — live video, audio & chat, trusted experts anytime."
        image={homeShareBanner}    
    />

      <HeroSection />
      {/* <SearchHomepage /> */}
      <CategoriesHomepage />
      <FeaturedExpertsHomepage />
      {/* <LiveSessionHomepageSection /> */}
      <BlogHomepage />
      <TestimonialsHomepage />
      {/* <MobileAppCTA/> */}
     
    </>
  );
}